import type { Routes } from '@angular/router';

export const REVIEWS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/reviews/layouts/reviews-layout/reviews-layout.component').then((m) => m.ReviewsLayoutComponent),
    },
];
